// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"D_tw h_jr h_fq h_ft h_fF h_dM h_z","menuItemSub":"D_tx h_dT h_fq h_fF","menuMainLink":"D_ty h_js h_hl","menuLink":"D_tz h_js h_hl","Link":"D_r6 v_r6 v_rn v_rJ"};